<template>
  <div id="app">
    <component :is="layout">
      <transition name="fade">
        <router-view/>
      </transition>
    </component>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import swal from 'sweetalert';
import { token } from '@/services/token'
import { mapActions } from 'vuex/dist/vuex.common.js';

export default {
  name: "App",
  methods: {
    showModal () {
      swal({
          title: 'Kamu telah kehabisan waktu, silakan login kembali untuk melanjutkan nya',
          icon: '/idle.jpeg'
        }).then(() => {
          // Hapus beforeunload listener agar tidak muncul alert browser saat redirect
          if (window.__beforeUnloadHandler) {
            window.removeEventListener('beforeunload', window.__beforeUnloadHandler)
            delete window.__beforeUnloadHandler
          }
          sessionStorage.clear()
          window.location.href = `/login?from=${encodeURIComponent(this.$route.fullPath)}`
        })
    },
    ...mapActions({
      logout: 'auth/logout'
    }),
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'auth/isLoggedIn',
    }),


    layout() {
      return (this.$route.meta.layout || 'guest') + '-layout'
    },
    isIdle() {
      return this.$store.state.idleVue.isIdle
    }
  },
  watch: {
    async isIdle (val) {
      if (this.isLoggedIn) {
        if (this.isIdle) {
          try {
            await this.logout()
          } catch (error) {}

          sessionStorage.clear()
          this.showModal()
        }
      }
    }
  }
};
</script>


<style lang="scss">
* {
  // font-family: 'Montserrat'
  /** this code to fixing the issue: Unexpected missing generic font family */
  font-family: Montserrat, Helvetica, Arial, Verdana, Tahoma, sans-serif;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.swal-modal img {
  width: 250px;
}

.swal-footer {
  text-align: center
}

</style>
